import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as sideBarActions from '../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import './ZoomWarningWindow.scss';
import { string } from '../../localization';
import * as Constants from '../../utilities/constants/Constants';

class OrderSampleDetailsWindow extends Component {
  state = {
    checkedIn: false,
    orderDetails: {
      name: null,
      email: null,
      message: ''
    },
    nameErrorFlag: false,
    emailErrorFlag: false
  };

  componentWillMount() {
    const { dispatchers, envData, sendPreviewWithLoupe } = this.props;
    const { orderDetails } = this.state;
    dispatchers.fabricCanvasActions.setShareLinkType(
      Constants.SHARE_TYPE_VIEW_LINK
    );

    if (envData.wallart_lite_mode && !sendPreviewWithLoupe) {
      this.setState({
        orderDetails: {
          ...orderDetails,
          email: ''
        }
      });
    } else if (envData && envData.partner && envData.partner_email) {
      this.setState({
        orderDetails: {
          ...orderDetails,
          email: envData.partner_email
        }
      });
    }
  }

  handleCheck = () => {
    const { orderDetails, checkedIn } = this.state;
    if (checkedIn) {
      this.setState({
        orderDetails: {
          ...orderDetails,
          name: '',
          message: '',
          email: ''
        }
      });
    }
    this.setState({
      checkedIn: !checkedIn
    });
  };

  handleValidation = () => {
    const { orderDetails } = this.state;
    const { dispatchers, sendPreviewWithLoupe } = this.props;

    const { name, email } = orderDetails;

    email.replace(/" "/g, '');
    const emailAddresses = email.split(',');
    const validName = dispatchers.fabricCanvasActions.isValidName(
      name,
      sendPreviewWithLoupe
    );
    const validEmailAddress = dispatchers.fabricCanvasActions.isEmailValid(
      emailAddresses
    );
    const hasValidProperties = validName && validEmailAddress;
    if (!validName) {
      this.setState({ nameErrorFlag: true });
    } else {
      this.setState({ nameErrorFlag: false });
    }
    if (!validEmailAddress) {
      this.setState({ emailErrorFlag: true });
    } else {
      this.setState({ emailErrorFlag: false });
    }

    if (hasValidProperties) {
      dispatchers.fabricCanvasActions.releaseOrderForSample(orderDetails);
    }
  };

  handleInputChange = (e, name) => {
    const { orderDetails } = this.state;

    if (name === 'name') {
      this.setState({
        orderDetails: {
          ...orderDetails,
          name: e.target.value
        }
      });
    } else if (name === 'email') {
      this.setState({
        orderDetails: {
          ...orderDetails,
          email: e.target.value
        }
      });
    } else if (name === 'message') {
      this.setState({
        orderDetails: {
          ...orderDetails,
          message: e.target.value
        }
      });
    }
  };

  render() {
    const {
      envData,
      sendPreviewWithLoupe,
      shareLinkType,
      dispatchers
    } = this.props;
    const {
      checkedIn,
      nameErrorFlag,
      emailErrorFlag,
      orderDetails
    } = this.state;

    let hasShareOption = false;
    if (envData.wallart_lite_mode && !sendPreviewWithLoupe) {
      hasShareOption = true;
    }
    const nameClass = nameErrorFlag
      ? 'input-container error-border-save'
      : 'input-container';

    return (
      <div className='sample-details-window'>
        <Modal
          className='order-details-modal2'
          isOpen
          // toggle={this.toggleScaleModal}
          contentClassName='border-0 bg-transparent'
          //   backdrop={true}
          centered
        >
          <ModalBody className='rounded-0 order-details-modal2'>
            <div>
              {!hasShareOption ? (
                <p
                  style={{
                    fontSize: '13px',
                    marginBottom: '0px',
                    marginTop: '10px',
                    color: 'red'
                  }}
                >
                  {string.ORDER_SAMPLE_EMAIL_DESCRIPTION}
                </p>
              ) : (
                <div>
                  <p
                    style={{
                      fontSize: '13px',
                      marginTop: '10px'
                    }}
                  >
                    {string.SHARE_LINK_LABEL}
                  </p>

                  {/* Edit link and view link */}
                  <div
                    className='d-flex align-items-cls input-group pt-20 pl-1 mt-20'
                    style={{ marginBottom: '10px' }}
                  >
                    <input
                      type='radio'
                      name='editLink'
                      value='input1'
                      onChange={() =>
                        dispatchers.fabricCanvasActions.setShareLinkType(
                          Constants.SHARE_TYPE_EDIT_LINK
                        )
                      }
                      checked={shareLinkType === Constants.SHARE_TYPE_EDIT_LINK}
                    />
                    <text className='pl-2 pt-20 mt-20'>
                      {string.SHARE_EDIT_LINK}
                    </text>
                  </div>
                  <div className='d-flex align-items-cls input-group pt-20 pl-1 '>
                    <input
                      type='radio'
                      name='viewLink'
                      value='input2'
                      onChange={() =>
                        dispatchers.fabricCanvasActions.setShareLinkType(
                          Constants.SHARE_TYPE_VIEW_LINK
                        )
                      }
                      checked={shareLinkType === Constants.SHARE_TYPE_VIEW_LINK}
                    />
                    <text className='pl-2'>{string.SHARE_VIEW_LINK}</text>
                  </div>

                  <p
                    style={{
                      fontSize: '13px',
                      marginTop: '10px',
                      color: 'red'
                    }}
                  >
                    {string.EMAIL_DIALOG_MESSAGE}
                  </p>
                </div>
              )}

              {/* CheckBox */}
              <div
                className='custom-control custom-checkbox'
                style={{ fontSize: '13px', marginTop: '10px' }}
              >
                <input
                  type='checkbox'
                  className='custom-control-input'
                  id='customCheck1'
                  defaultChecked={checkedIn}
                  onChange={this.handleCheck}
                />
                <label className='custom-control-label' htmlFor='customCheck1'>
                  {string.EMAIL_CHECKBOX_MESSAGE}
                </label>
              </div>

              {emailErrorFlag ? (
                <div style={{ marginTop: 10, color: 'red' }}>
                  {string.INVALID_EMAIL_ADDRESS_KEY}
                </div>
              ) : null}

              {/* Name */}
              {!hasShareOption ? (
                <div
                  className='d-flex align-items-cls info-container'
                  style={{ marginTop: 10 }}
                >
                  <text
                    className={[
                      'sample-label',
                      'pr-2',
                      !checkedIn ? 'disabled-text' : null
                    ].join(' ')}
                    style={{ fontSize: 15 }}
                  >
                    {string.NAME_KEY}
                  </text>
                  <div className={nameClass}>
                    <input
                      className='form-control small-text-field'
                      disabled={!checkedIn}
                      value={orderDetails.name}
                      onChange={(e, name = 'name') =>
                        this.handleInputChange(e, name)
                      }
                    />
                  </div>
                </div>
              ) : null}

              {/* Email */}
              <div
                className='d-flex align-items-cls info-container'
                style={{ marginTop: 10 }}
              >
                <text
                  className={[
                    'sample-label',
                    'pr-2',
                    !checkedIn ? 'disabled-text' : null
                  ].join(' ')}
                >
                  {string.EMAIL_ADDRESS_KEY}
                </text>
                <div className='input-container'>
                  <input
                    className='form-control  small-text-field'
                    style={{
                      color: !checkedIn ? 'rgba(74,74,74,0.7)' : null
                    }}
                    type='email'
                    disabled={!checkedIn}
                    value={orderDetails.email}
                    onChange={(e, name = 'email') =>
                      this.handleInputChange(e, name)
                    }
                  />
                </div>
              </div>

              {/* Message */}
              <div
                className='d-flex align-items-cls info-container'
                style={{ marginTop: 20 }}
              >
                <text
                  className={[
                    'sample-label',
                    'pr-2',
                    !checkedIn ? 'disabled-text' : null
                  ].join(' ')}
                >
                  {string.MESSAGE_KEY}:
                </text>
                <div className='input-container msg-container'>
                  <input
                    className='form-control large-text-field'
                    // placeholder={string.PLACEHOLDER_EMAIL_KEY}
                    // type="email"
                    disabled={!checkedIn}
                    onChange={(e, name = 'message') =>
                      this.handleInputChange(e, name)
                    }
                    value={orderDetails.message}
                  />
                </div>
              </div>

              <div style={{ float: 'right', marginTop: '12px' }}>
                <button
                  type='button'
                  className='cancel-btn-modal'
                  onClick={() => {
                    dispatchers.fabricCanvasActions.showOrderSampleDetailsWindow(
                      false
                    );
                  }}
                >
                  {string.CANCEL_TEXT_KEY}
                </button>

                <button
                  type='button'
                  className={`ok-btn ${
                    !checkedIn || !orderDetails.email
                      ? 'ok-btn-disabled'
                      : 'ok-btn-enabled'
                  }`}
                  onClick={e => this.handleValidation(e)}
                >
                  {hasShareOption ? string.SEND_KEY : string.OK_KEY}
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showPixelationWarningField: state.fabricCanvas.showPixelationWarningField,
    envData: state.modal.envData,
    sendPreviewWithLoupe: state.fabricCanvas.sendPreviewWithLoupe,
    shareLinkType: state.fabricCanvas.shareLinkType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderSampleDetailsWindow);
